import { Signal } from "@suse-o11y/signal";
import { usePermanent } from "@suse-o11y/use-permanent";
import React from "react";

import { WidgetExpandContextProvider } from "./widget-context";

export const WidgetBoundary: React.FC<React.PropsWithChildren> = ({ children }) => {
	const value = usePermanent(() => Signal(new Map<string, boolean>()));

	return <WidgetExpandContextProvider value={value}>{children}</WidgetExpandContextProvider>;
};
